import { ReactElement, useEffect } from 'react';

import { Permission, SubscriptionStatus } from '@localstack/types';
import { SubscriptionService, useApiGetter, useRoutes } from '@localstack/services';

import { BaseLayout } from '~/layouts';
import { AppRoute } from '~/config';
import { useAuthProvider } from '~/hooks/useAuthProvider';

import { ContainerView, ContentBox, NoNavbarHeader } from './components';
import { PricingPlansContent } from './PricingPlansContent';

/**
 * No-navigation lockout variant of the pricing page, shown when a workspace has no valid
 * subscription. Reuses the shared pricing-plan logic; only the surrounding chrome differs.
 */
export const TrialExpiredPage = (): ReactElement => {
  const { goto } = useRoutes();
  const { can } = useAuthProvider();

  const { data: subscriptions, isLoading } = useApiGetter(SubscriptionService, 'listSubscriptions', [], {
    suppressErrors: true,
    enable: can(Permission.READ_SUBSCRIPTIONS),
  });

  useEffect(() => {
    if (!isLoading && subscriptions?.some((sub) => sub.status !== SubscriptionStatus.CANCELED)) {
      goto(AppRoute.GETTING_STARTED);
    }
  }, [goto, isLoading, subscriptions]);

  return (
    <BaseLayout hideNavigation>
      <NoNavbarHeader />
      <ContainerView>
        <ContentBox>
          <PricingPlansContent variant="trial-expired" />
        </ContentBox>
      </ContainerView>
    </BaseLayout>
  );
};
